// extracted by mini-css-extract-plugin
module.exports = {"CustomerSearch":"CustomerSearch_CustomerSearch__25N1x","CustomerSearch__search":"CustomerSearch_CustomerSearch__search__2FjC3"};